import { Box, Button, SxProps, Theme, Typography } from '@mui/material';

import type { SidebarFooterCard } from './sidebar.types';

type FooterCardProps = Readonly<{
  card: SidebarFooterCard;
}>;

export const FooterCard = ({ card }: FooterCardProps) => (
  <Box id={card.id} sx={containerSx}>
    <Box sx={textStackSx}>
      <Typography variant="text-lg-semibold" sx={headingSx}>
        {card.heading}
      </Typography>
      {card.subtitle && (
        <Typography variant="text-sm-regular" sx={subtitleSx}>
          {card.subtitle}
        </Typography>
      )}
    </Box>
    <Button id={`${card.id}-cta`} hierarchy="Primary" size="md" fullWidth onClick={card.ctaOnClick}>
      {card.ctaLabel}
    </Button>
  </Box>
);

const containerSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-2xl'],
  backgroundColor: backrs.colors['Colors/Background/bg-primary'],
  border: `1px solid ${backrs.colors['Colors/Text/text-primary']}`,
  borderRadius: backrs.radius['radius-xl'],
  px: backrs.spacing['spacing-xl'],
  py: backrs.spacing['spacing-2xl'],
  width: '100%',
});

const textStackSx: SxProps<Theme> = ({ backrs }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: backrs.spacing['spacing-xxs'],
});

const headingSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-primary'],
  wordBreak: 'break-word',
});

const subtitleSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-tertiary'],
  wordBreak: 'break-word',
});
